import React, {Component} from 'react';
import {Grid, Col, Row, Button,ControlLabel, FormControl} from 'react-bootstrap';
import classNames from 'classnames';

import Select   from 'react-select'
import config from  '../../../config';
import {prepareSelectOptionsList} from 'util/Utils';
import Datetime from "react-datetime";
import {Link} from "react-router";

var statusOptions = [
    {value: 'NotStarted', label: 'Not Started'},
    {value: 'InProgress', label: 'In Progress'},
    {value: 'Complete', label: 'Complete'}
];
export default class InventoryProjectsSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);




        this.state = {
            filterOptions: {
                searchFields: _.isUndefined(this.props.location.query.searchFields) ? 'Status' : this.props.location.query.searchFields,
                perPage: _.isUndefined(this.props.location.query.perPage) ? 30 : this.props.location.query.perPage,
                searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
                locationSearch: _.isUndefined(this.props.location.query.locationSearch) ? '' : this.props.location.query.locationSearch,

                Market: _.isUndefined(this.props.location.query.Markets) ? 'Denver' : this.props.location.query.Markets,
                fromStartDate: _.isUndefined(this.props.location.query.fromStartDate) ? '' : moment(this.props.location.query.fromStartDate),
                Statuses:  _.isUndefined(this.props.location.query.Statuses) ?  [] : _.isArray(this.props.location.query.Statuses) ? _.map(this.props.location.query.Statuses, function (value) {
                    return _.find(statusOptions, {value:value})
                }) : [_.find(statusOptions, {value:this.props.location.query.Statuses})],

            }
        };
    };

    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }



    getSearchParams(filtersChanged = {}) {
        var filterOptions = {...this.state.filterOptions, ...filtersChanged};
        console.log('filterOptions', filterOptions);
        var queryParams = {};

            queryParams.perPage = filterOptions.perPage;
console.log('filterOptions.searchFields', filterOptions.searchFields  );
        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
            if (filterOptions.searchFields == 'wa') {
                queryParams.fieldsToSearch = ['WarehouseLocations.LocationArea']
                queryParams.searchFields ='wa'
            }else  if (filterOptions.searchFields == 'wl') {
                queryParams.fieldsToSearch = ['WarehouseLocations.LocationName']
                queryParams.searchFields ='wl'
            }else  if (filterOptions.searchFields == 'nwl') {
                queryParams.fieldsToSearch = ['NewWarehouseLocation']
                queryParams.searchFields ='nwl'
            }
        }

        if ( filterOptions.Market ) {
            queryParams.Markets =  [ filterOptions.Market ]
        }
        if (filterOptions.Statuses) {
            queryParams.Statuses = _.map(filterOptions.Statuses, 'value')
        }
        if (filterOptions.fromStartDate !== '') {
            queryParams.fromStartDate = filterOptions.fromStartDate.toISOString()
        }
        if (_.get(filterOptions, 'deliveryMethods', []).length ) {
            queryParams.deliveryMethods = _.map(filterOptions.deliveryMethods, 'value')
        }
        return {queryParams}

    }


    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions})
       // this.props.search());
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }


    onCreateTimeChange(option, createTimeOptionName) {
        var updateOptions = {...this.state.filterOptions,  [createTimeOptionName]: option};
        this.setState({'filterOptions': updateOptions}, function () {
            this.props.search();
        });
    }




    render() {
      console.log('this.state', this.state  );
          return (
            <div className="product-search-block">

                <Row>
                    <Col xs={9} sm={6} md={6} lg={3} className="pleft0  top10">
                        <Col xs={12} className="top10 pright0">
                            <Button
                              style={_.extend({width:'100%' }, this.props.currentTab == 'SpotChecks' ? {borderColor:config.Colors.pink,  backgroundColor:config.Colors.pink}: {  })}
                                    className={classNames('btn btn-lg btn-primary ' )}

                                    onClick={ ()=>this.props.changeTab({currentTab:'SpotChecks'})  }>
                                Spot Checks
                            </Button>
                        </Col>
                    </Col>
                    <Col xs={9} sm={6} md={6} lg={3} className="pleft0  top10">
                        <Col xs={12} className="top10 pright0">
                            <Button   className="btn btn-lg btn-primary"
                                      style={_.extend({width:'100%'}, this.props.currentTab == 'MonthlyReports' ? {borderColor:config.Colors.pink,  backgroundColor:config.Colors.pink}: {  })}
                                      onClick={ ()=>this.props.changeTab({currentTab:'MonthlyReports'})  }>
                               Monthly Reports
                            </Button>
                        </Col>
                    </Col>
                    <Col xs={9} sm={6} md={6}  lg={3} className="pleft0  top10">
                        <Col xs={12} className="top10 pright0">
                            <Button  className="btn  btn-lg btn-primary"
                                    style={_.extend({width:'100%'}, this.props.currentTab == 'BiAnnualReports' ?{borderColor:config.Colors.gr,  backgroundColor:config.Colors.pink}: {  })}
                                     onClick={ ()=>this.props.changeTab({currentTab:'BiAnnualReports'})  }>
                              Bi-Annual Reports
                            </Button>
                        </Col>
                    </Col>
                    <Col xs={9} sm={6} md={6}  lg={3} className="pleft0  top10">
                        <Col xs={12} className="top10 pright0">
                            <Button  className="btn  btn-lg btn-primary"
                                     style={_.extend({width:'100%'},  )}
                                     onClick={ ()=>this.props.addInventoryProject()  }>
                                Start New
                            </Button>
                        </Col>
                    </Col>

                    {/*<Col md={3} xs={6} className="pright5 top20 pull-right">*/}
                        {/*<Button bsStyle="link" className="pull-right">*/}
                            {/*<Link className="pull-right " onClick={()=>{*/}
                                {/*this.props.addInventoryProject()*/}
                            {/*} }>Start New</Link>*/}
                        {/*</Button>*/}
                    {/*</Col>*/}
                </Row>
                <Row >
                    <Col md={3} xs={6} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={_.reject(config.perPageSelectOptions, {value:'all'})}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={this.state.filterOptions.perPage}
                        />
                    </Col>

                    <Col md={3} xs={6} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <Select
                            tabIndex="0"
                            clearable={true}
                            placeholder="Field to search"
                            options={ [
                                {value:'wl', label:'Warehouse location'},
                                {value:'nwl', label:'New warehouse location'},
                                {value:'wa', label:'Warehouse area'}]
                            }
                            onChange={ (option) =>{
                                this.setState({'filterOptions': {...this.state.filterOptions,
                                    searchFields:option ? option.value : null}}, function () {
                                    this.props.search();
                                });
                            }}
                            value={this.state.filterOptions.searchFields}
                        />
                    </Col>
                    <Col md={3} xs={6} className="top10">

                            <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                      onChange={(value) => this.onCreateTimeChange(value, 'fromStartDate')}
                                      value={this.state.filterOptions.fromStartDate}
                                      inputProps={{placeholder: 'Start Date'}}/>


                    </Col>
                    <Col md={3} xs={6} className="top10">

                        <Select
                            tabIndex="0"
                            placeholder="Status"
                            clearable={false}
                            multi
                            options={statusOptions}
                            onChange={(selectedOptions) => {
                                this.setState({'filterOptions': {...this.state.filterOptions, Statuses: selectedOptions}}, function () {
                                    this.props.search({page: 1})
                                });
                            }}
                            value={this.state.filterOptions.Statuses}
                        />
                    </Col>

                </Row>

                <Row className='fulfillment-search-block '>
                    <Col md={3} xs={6} className="top10">
                        <Select
                            tabIndex="0"
                            clearable={false}
                            placeholder="Product location"
                            options={   _.map(config.warehouseData, item => {
                                return {value: item.MarketName, label: item.MarketName}
                            })}
                            onChange={ (option) =>{
                                this.setState({'filterOptions': {...this.state.filterOptions, Market:option ? option.value : null}}, function () {
                                    this.props.search();
                                });
                            }}

                            value={this.state.filterOptions.Market}
                        />
                    </Col>

                    <Col md={3} xs={6} className="pull-right  top10">
                        <button className="pull-right btn btn-primary" disabled={this.props.pending} onClick={(event) => this.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>
                </Row>
            </div>
        );

    }
}



